import React, { Component, Fragment } from 'react';

import DesktopAlarm from './Desktop/DesktopAlarm';
import MobileAlarm from './Mobile/Mobile';

export default class Alarm extends Component {
  render() {
    const { alarm, selectedAlarm, closeAlarm, openAlarm, alarms } = this.props;
    let alarmm;
    if (window.innerWidth > 900) {
      alarmm = <DesktopAlarm
        alarm={alarm}
        closeAlarm={closeAlarm}
        openAlarm={openAlarm}
        alarms={alarms}
      />
    }
    else if (window.innerWidth < 900) {
      alarmm = <MobileAlarm
        alarm={alarm}
        closeAlarm={closeAlarm}
        selectedAlarm={selectedAlarm}
        openAlarm={openAlarm}
        alarms={alarms}
      />
    }
    return (
      <Fragment>{alarmm}</Fragment>
    );
  }
}